import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { api } from '@/lib/api';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

type MigrationTarget = 'blog' | 'incentive' | 'event' | 'luxury';

export function ContentMigrationPage() {
  const navigate = useNavigate();
  const [url, setUrl] = useState('');
  const [target, setTarget] = useState<MigrationTarget>('blog');
  const [migrating, setMigrating] = useState(false);
  const migrate = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setMigrating(true);
    try {
      const item = await api.post<{ id: string; target: 'blog' | 'case'; skippedImageCount: number }>('/blog/migrate', {
        url,
        target,
      });
      toast.success('Concept geïmporteerd.');
      if (item.skippedImageCount)
        toast.warning(
          `${item.skippedImageCount} ${item.skippedImageCount === 1 ? 'afbeelding kon' : 'afbeeldingen konden'} niet worden geïmporteerd.`
        );
      navigate(item.target === 'blog' ? `/blog/${item.id}/bewerken` : `/cases/${item.id}/bewerken`);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Migratie is niet gelukt.');
    } finally {
      setMigrating(false);
    }
  };
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Oude inhoud migreren</h1>
        <p className="mt-1 text-muted-foreground">
          Importeer één artikel of case van fame-travel.be als concept, inclusief afbeeldingen.
        </p>
      </div>
      <form className="space-y-4 rounded-md border p-6" onSubmit={migrate}>
        <label className="block space-y-2">
          <span className="font-medium">Maak een</span>
          <select
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
            value={target}
            onChange={event => setTarget(event.target.value as MigrationTarget)}
          >
            <option value="blog">Blogartikel</option>
            <option value="incentive">Incentive case</option>
            <option value="event">Event case</option>
            <option value="luxury">Luxury Travel case</option>
          </select>
        </label>
        <label className="block space-y-2">
          <span className="font-medium">Oude artikel-URL</span>
          <Input
            type="url"
            required
            value={url}
            onChange={event => setUrl(event.target.value)}
            placeholder="https://www.fame-travel.be/..."
          />
        </label>
        <p className="text-sm text-muted-foreground">
          De inhoud en afbeeldingen worden via dezelfde media-verwerking als manuele uploads opgeslagen. Controleer het
          concept vóór publicatie.
        </p>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={() => navigate('/blog')}>
            Annuleren
          </Button>
          <Button type="submit" disabled={migrating}>
            {migrating ? 'Migreren…' : 'Migreren als concept'}
          </Button>
        </div>
      </form>
    </div>
  );
}
